import React, { useState, useEffect } from "react";
import { useLocation, Navigate } from "react-router-dom";
import ReactDOM from "react-dom";
import store from 'store/store';
import { connect, useSelector } from 'react-redux';
import { AxiosAdmin as Axios, AxiosOperator, AxiosUser, AxiosGeneral, AxiosErrorHandling } from "connection/Axios"
import { dictionary } from "components/common/Config";
import { Form, Button, Col, Alert } from 'react-bootstrap';
import { useForm, Controller, useFieldArray } from "react-hook-form";
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import loginCover1 from 'assets/images/login-images/login-cover.svg'
import loginCover2 from 'assets/images/login-images/01.jpeg'
import logoIcon from 'assets/images/logo-icon.png'



function Login(props) {
    const user = useSelector((state) => state.user);
    const state2 = store.getState()
    // console.log('state:',state2)
    // console.log('user:',user)

    const [serverErrors, setServerErrors] = useState(null)
    const [errorMessages, setErrorMessages] = useState({})
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [logging, setLogging] = useState(false)
    const reduxState = store.getState()

    // console.log('reduxState:',reduxState)
    // console.log('dictionary:',dictionary['base-'+dictionary.app].loginCover)
    document.title = reduxState?.appName

    const [hasError, setHasError] = useState(false)
    const [target, setTarget] = useState(false)

    const { state } = useLocation();

    const schema = yup.object().shape({
        mobile: yup.string().min(11).required('وارد کردن مقدار الزامیست'),
        password: yup.string().required('وارد کردن مقدار الزامیست'),
    });

    const { control, register, handleSubmit, formState: { errors }, reset } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            mobile: '',
            password: ''
        }
    });



    const onSubmit = async (data) => {
        setLogging(true)
        Axios.post('/login', JSON.stringify(data))
        .then(async (res) => {
            let data = res.data
            let userInfo = {
                id: data.data.id,
                name: data.data.name,
                lastName: data.data.last_name,
                email: data.data.email,
                avatar: data.data.avatar,
                token: data.data.token,
                type: data.data.type,
            }
            // console.log('userInfo.token:',userInfo.token)
            Axios.defaults.headers.Authorization = 'Bearer ' + userInfo.token
            AxiosOperator.defaults.headers.Authorization = 'Bearer ' + userInfo.token
            AxiosUser.defaults.headers.Authorization = 'Bearer ' + userInfo.token
            AxiosGeneral.defaults.headers.Authorization = 'Bearer ' + userInfo.token
            props.dispatch({ type: 'LOGIN', payload: userInfo });
            setIsSubmitted(true);
        })
        .catch((err) => {
            AxiosErrorHandling(err)
            setServerErrors(err.response.data.data)
            setLogging(false)
        })
    };


    useEffect(() => {
        setLogging(true)
        // console.log('Login - useEffect')
        document.title = dictionary['base-'+dictionary.app].title_fa + ' - فرم ورود';
        if(localStorage.getItem('token')) {
            // console.log('Login - IF')
            let token = localStorage.getItem('token')
            if(token !== null && token !== undefined) {
                Axios.post('/check-token', JSON.stringify({token: token}))
                .then(async (res) => {
                    let data = res.data
                    let userInfo = {
                        id: data.data.id,
                        name: data.data.name,
                        lastName: data.data.last_name,
                        email: data.data.email,
                        avatar: data.data.avatar,
                        type: data.data.type,
                        token: token,
                    }
                    // setIsSubmitted(true);
                    // Axios.defaults.headers.Authorization = 'Bearer ' + userInfo.token
                    Axios.defaults.headers.Authorization = 'Bearer ' + userInfo.token
                    AxiosOperator.defaults.headers.Authorization = 'Bearer ' + userInfo.token
                    AxiosUser.defaults.headers.Authorization = 'Bearer ' + userInfo.token
                    AxiosGeneral.defaults.headers.Authorization = 'Bearer ' + userInfo.token
                    store.dispatch({ type: 'LOGIN', payload: userInfo });
                    setIsSubmitted(true)
                })
                .catch((err) => {
                    if(parseInt(err.response.status) === 401) {
                        localStorage.removeItem('token')
                    } else if(parseInt(err.response.status) === 500) {
                        setHasError(true)
                        setTarget('/500')
                    } else {
                        setHasError(true)
                        setTarget('/404')
                    }
                })
                .finally(() => {
                    setLogging(false)
                })
            }
        } else {
            // console.log('Login - ELSE')
            setLogging(false)
        }
        
    }, [])

    if(hasError)
        return <Navigate to={target} replace />

    return (
        <>
            {
                isSubmitted ? 
                <Navigate to={(state !== null && state?.pathname !== '/') ? state?.pathname : "/dashboard"} replace />
                :
                <div className="wrapper">
                    <div className="section-authentication-cover">
                        <div className="">
                            <div className="row g-0">

                                <div className="col-12 col-xl-7 col-xxl-8 auth-cover-left align-items-center justify-content-center d-none d-xl-flex">

                                    <div className="card shadow-none bg-transparent shadow-none rounded-0 mb-0" style={{border:'0px'}}>
                                        <div className="card-body">
                                            {/* <img src={dictionary['base-fjr']?.logoIcon} className="img-fluid auth-img-cover-login" width="650" alt=""/> */}
                                            <img src={dictionary.app === 'fjr' ? loginCover1 : loginCover2} className="img-fluid auth-img-cover-login" width="650" alt=""/>
                                        </div>
                                    </div>
                                    
                                </div>

                                <div className="col-12 col-xl-5 col-xxl-4 auth-cover-right align-items-center justify-content-center">
                                    <div className="card rounded-0 m-3 shadow-none bg-transparent mb-0" style={{border:'0px'}}>
                                        <div className="card-body p-sm-5">
                                            <div className="">
                                                <div className="mb-3 text-center">
                                                    <img src={logoIcon} width="60" alt="" />
                                                </div>
                                                <div className="text-center mb-4">
                                                    <h5 className="">{reduxState?.appName}</h5>
                                                    <p className="mb-0" style={{fontFamily:'Vazir'}}>فرم ورود به حساب کاربری</p>
                                                </div>
                                                <div className="form-body">
                                                    {
                                                        ( serverErrors !== null && serverErrors !== undefined ) && 
                                                        <Alert variant="danger">
                                                            <h5 className="text-danger">خطا!</h5>
                                                            {
                                                                serverErrors?.map((item,index) => {
                                                                    return (<p key={index}>{item}</p>)
                                                                })
                                                            }
                                                        </Alert>
                                                    }
                                                    <Form onSubmit={handleSubmit(onSubmit)} className="row g-3">
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>موبایل</Form.Label>
                                                            <Controller
                                                                control={control}
                                                                name="mobile"
                                                                render={({ field, onChange }) => (
                                                                    <Form.Control 
                                                                        type="text"
                                                                        onChange={(e) => { field.onChange(e) }}
                                                                        value={field.value ? field.value : ''}
                                                                        className="form-control"
                                                                        isInvalid={errors['mobile']?.message}
                                                                        dir="ltr"
                                                                    />
                                                                )}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors['mobile']?.message}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group className="mb-3">
                                                            <Form.Label>رمز ورود</Form.Label>
                                                            <Controller
                                                                control={control}
                                                                name="password"
                                                                render={({ field, onChange }) => (
                                                                    <Form.Control 
                                                                        type="password"
                                                                        onChange={(e) => { field.onChange(e) }}
                                                                        value={field.value ? field.value : ''}
                                                                        className="form-control"
                                                                        isInvalid={errors['password']?.message}
                                                                        dir="ltr"
                                                                    />
                                                                )}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors['password']?.message}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <a className="link" href="forget-password.html">بازنشانی رمز ورود</a>
                                                        <div className="form-group mb-0">
                                                            <Button type="submit" className="btn btn-primary btn-block w-100"
                                                                disabled={logging}
                                                            >
                                                                {
                                                                    logging ? 'در حال اعتبارسنجی ...' : 'ورود'
                                                                }
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            }
            
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        number: state.number,
        user: state.user
    };
}

export default connect(mapStateToProps)(Login);